<template>
    <div>
        <!-- Header -->
        <div class="header bg-gradient-success py-7 py-lg-7 pt-lg-7">
            <div class="container">
                <div class="header-body text-center mb-7">
                    <div class="row justify-content-center">
                        <div class="col-xl-5 col-lg-6 col-md-8 px-5">
                            <h1 class="text-white">Hello Again!</h1>
                            <blockquote class="text-lead text-white">
                                {{quote.message}}
                                <cite>{{quote.author}}</cite>
                            </blockquote>
                        </div>
                    </div>
                </div>
            </div>
            <div class="separator separator-bottom separator-skew zindex-100">
                <svg x="0" y="0" viewBox="0 0 2560 100" preserveAspectRatio="none" version="1.1"
                        xmlns="http://www.w3.org/2000/svg">
                    <polygon class="fill-default" points="2560 0 2560 100 0 100"></polygon>
                </svg>
            </div>
        </div>
        <!-- Page content -->
        <div class="container mt--8 pb-5">
            <div class="row justify-content-center">
                <div class="col-lg-5 col-md-7">
                    <div class="card bg-secondary border-0 mb-0 login-form-card">
                        <div class="card-body px-lg-5 py-lg-5">
                            <div v-if="showForgotPasswordEmailSentMessage" class="text-center text-danger mb-4">
                                We have sent you the forgot password email
                            </div>
                            <div class="text-center text-muted mb-4">
                                <small>Sign in with your credentials</small>
                            </div>
                            <form role="form" v-if="!showIdentifyDeviceMessage">
                                <base-input alternative
                                        class="mb-3"
                                        prepend-icon="ai ai-email"
                                        :placeholder="$t('auth.emailAddress')"
                                        type="email"
                                        name="email"
                                        autofocus
                                        v-validate="userValidations.email"
                                        :error="getError('email')"
                                        v-model="user.email"
                                        @keydown.enter="validate">
                                </base-input>

                                <base-input
                                        alternative
                                        class="mb-3"
                                        prepend-icon="ai ai-padlock-unlocked"
                                        type="password"
                                        :placeholder="$t('auth.password')"
                                        name="password"
                                        v-validate="userValidations.password"
                                        :error="getError('password')"
                                        v-model="user.password"
                                        @keydown.enter="validate">
                                </base-input>

                                <base-checkbox v-model="user.rememberMe">Remember me</base-checkbox>
                                <div class="text-center">
                                    <base-button
                                            type="primary"
                                            class="my-4"
                                            :loading="loggingIn"
                                            @click="validate">
                                        {{ $t('auth.login') }}
                                    </base-button>
                                </div>
                            </form>
                        </div>
                        <div class="identify-device-message" :class="{show: showIdentifyDeviceMessage}">
                            <div class="message-content">
                                <div class="message-icon" v-if="false">
                                    <i class="ai ai-warning-triangle" aria-hidden="true"></i>
                                </div>
                                <div class="message-title text-primary">Identify your device</div>
                                <div class="message-text">Please check your email</div>
                            </div>
                        </div>
                    </div>
                    <div class="row mt-3">
                        <div class="col-12 text-center">
                            <router-link to="/forgotPassword" class="text-light">
                                <small>Forgot password?</small>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import VeeValidateMixin from '../../mixins/vee-validate-mixin'
    import Cookies from 'js-cookie';
    import {mapActions, mapGetters} from 'vuex'

    export default {
        mixins: [VeeValidateMixin],
        data() {
            return {
                loggingIn: false,
                showForgotPasswordEmailSentMessage: false,
                user: {
                    email: '',
                    password: '',
                    rememberMe: true
                },
                quote: {
                    author: '',
                    message: ''
                },
                userValidations: {
                    email: {
                        required: true,
                        email: true
                    },
                    password: {
                        required: true,
                        min: 5,
                    }
                }
            }
        },
        computed: {
            ...mapGetters({
                showIdentifyDeviceMessage: 'getIdentifyDeviceMessageState'
            })
        },
        methods: {
            ...mapActions({
                login: 'login'
            }),
            async validate() {
                const isValid = await this.$validator.validateAll();

                if (isValid) {
                    this.loggingIn = true;
                    await this.$store.dispatch('login', this.user)
                        .then(() => {
                        })
                        .catch(() => {
                        })
                        .then(() => {
                            this.loggingIn = false;
                        })
                }
            }

        },
        created() {
            const userLoggedIn = this.$store.getters.getUser;
            const token = Cookies.get('access_token');
            console.log(userLoggedIn, token);

            if(userLoggedIn && token){
                console.log("Logging out...");
                Cookies.remove('access_token');
                window.location.reload(true);
            }

            if (sessionStorage.getItem('forgotPasswordEmailSent')) {
                this.showForgotPasswordEmailSentMessage = true;
                sessionStorage.removeItem('forgotPasswordEmailSent');
            }
        },
        mounted() {
            const emailVerifiedCookie = this.$cookies.get('emailVerified');

            if (emailVerifiedCookie) {
                this.$cookies.remove('emailVerified');

                setTimeout(() => {
                    this.$notify({
                        iconClass: 'ai ai-check',
                        title: emailVerifiedCookie,
                    })
                }, 1250)
            }

        },
    };
</script>

<style lang="scss">
    .login-form-card {
        position: relative;

        .identify-device-message {
            position: absolute;
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;
            display: flex;
            justify-content: center;
            align-items: center;
            text-align: center;
            background-color: #fff;
            border-radius: 10px;
            z-index: 1;
            opacity: 0;
            visibility: hidden;
            transition: opacity 150ms ease-in;
            color: #172b4d;

            &.show {
                opacity: 1;
                visibility: visible;
            }

            .message {
                &-icon {
                    font-size: 36px;

                    i {
                        width: auto;
                    }
                }

                &-title {
                    font-size: 22px;
                }

                &-text {
                    font-size: 17px;
                }
            }
        }
    }
</style>
